import { makeStyles } from "@material-ui/core";

const usePriceStyles = makeStyles((theme: any) => ({
  root: {
    backgroundColor: "#f8f8f8",
    paddingTop: "10%",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    [theme.breakpoints.down("767")]: {
      flexDirection: "column",
      alignItems: "center",
      "& .container-responsive": {
        width: "90%",
        margin: "0 auto 35px",
      },
    },
  },
  rightPaneTitle: {
    color: "#202020",
    fontSize: "32px",
    lineHeight: "46px",
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: "7rem",
    wordBreak: "break-word",
    [theme.breakpoints.down("767")]: {
      display: "none",
    },
  },
  rightPaneTitleResponsive: {
    color: "#202020",
    wordBreak: "break-word",
    fontSize: "2rem",
    lineHeight: "46px",
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: "7rem",
    display: "none",
    [theme.breakpoints.down("767")]: {
      display: "block",
      fontSize: "1.5rem",
    },
  },
  leftPane: {
    width: "55%",
    [theme.breakpoints.down("767")]: {
      width: "100%",
    },
  },
  rightPane: {
    width: "35%",
    [theme.breakpoints.down("991")]: {
      width: "42%",
    },
    [theme.breakpoints.down("767")]: {
      width: "100%",
      "& > div:not(.summary)": {
        width: "100%",
      },
    },
  },
  divider: {
    width: "80px",
    margin: "auto",
    height: 2,
    background: "#202020",
    border: "none",
  },
  orderPrice: {
    fontSize: 48,
    textAlign: "center",
    marginTop: 40,
    "& span": {
      fontSize: 28,
    },
  },
  checkbox: {
    color: "#9CA3AF",
    textAlign: "center",
    marginTop: "60px",
    "& .MuiCheckbox-root": {
      "&.Mui-checked": {
        color: "#9CA3AF",
        "& .MuiSvgIcon-root": {
          "& path": {
            fill: "#9CA3AF",
          },
        },
      },
      "&:hover": {
        background: "transparent",
      },
    },
    [theme.breakpoints.down("1200")]: {
      textAlign: "unset",
    },
    [theme.breakpoints.down("767")]: {
      textAlign: "center",
    },
  },
  skipBtn: {
    width: "257px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#FFFFFF",
    backgroundColor: "#245fad",
    border: "1px solid #245fad",
    transition: "0.3s",
    cursor: "pointer",
    height: "51px",
    borderRadius: "10px",
    margin: "29px auto 16px",
    "&:hover": {
      backgroundColor: "#245fad",
      color: "white",
      borderColor: "#245fad",
    },
    "&:disabled": {
      background: "#245fad",
      opacity: "0.5",
      cursor: "not-allowed",
    },
  },
  prevBtn: {
    width: "257px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#245fad",
    backgroundColor: "#FFFFFF",
    border: "1px solid #245fad",
    transition: "0.3s",
    cursor: "pointer",
    height: "51px",
    borderRadius: "10px",
    margin: "29px auto 16px",
    "&:hover": {
      backgroundColor: "#245fad",
      color: "white",
      borderColor: "#245fad",
    },
  },
  dialogButtonsSize: {
    width: 312,
    [theme.breakpoints.down("575")]: {
      width: 240,
      marginTop: 15,
    },
  },
  dialogRoot: {
    "& .MuiPaper-root": {
      padding: "15px 42px 38px",
      borderRadius: 10,
      [theme.breakpoints.down("575")]: {
        padding: "10px 15px 10px",
      },
      [theme.breakpoints.down("430")]: {
        padding: "10px 0 20px",
      },
    },
    "& .MuiBackdrop-root": {
      opacity: "0.8!important",
      // background: "#000000",
    },
    "& .MuiDialogActions-root": {
      [theme.breakpoints.down("575")]: {
        padding: 0,
      },
    },
  },
  closeIcon: {
    position: "absolute",
    top: 22,
    right: 22,
    cursor: "pointer",
    [theme.breakpoints.down("575")]: {
      width: 15,
      height: 15,
    },
  },
  spinnerWrapper: {
    margin: "100px auto 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paymentIconsStyles: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  paymentIconsWrapper: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& .MuiButtonBase-root": {
      padding: "2px!important",
    },
    [theme.breakpoints.down("1200")]: {
      flexDirection: "column",
      "& .responsive-icon": {
        marginBottom: 10,
      },
    },
    [theme.breakpoints.down("767")]: {
      flexDirection: "row",
      "& .responsive-icon": {
        marginBottom: 0,
      },
    },
  },
  paymentIconsArea: {
    margin: "16px 0",
    [theme.breakpoints.down("1200")]: {
      margin: "16px 0 16px 7px",
    },
  },
  summaryTitleArea: {
    background: "#d3d3d3",
    padding: "12px 8px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px",
  },
  summaryArea: {
    "&.summary": {
      [theme.breakpoints.down("767")]: {
        width: "70%",
        margin: "0 auto",
      },
    },
  },
}));

export default usePriceStyles;
